module.exports = __webpack_public_path__ + "static/media/gating.8e5911f0.svg";